var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("emd-modal", {
    attrs: { open: _vm.isOpen, "has-header": "", "has-footer": "" },
    on: { close: () => _vm.$emit("onClose") },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("h2", [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("modal.pix.delete-pix-key-modal.title")) +
                  " "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _vm.error
              ? _c("emd-alert", {
                  attrs: {
                    variant: "danger",
                    title: _vm.$t("account.settings.alert.error-title"),
                  },
                  on: {
                    cancel: function ($event) {
                      _vm.error = null
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "content",
                        fn: function () {
                          return [_vm._v(" " + _vm._s(_vm.error) + " ")]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3792905601
                  ),
                })
              : _vm._e(),
            _c(
              "emd-alert",
              {
                attrs: {
                  variant: "info",
                  noClose: "",
                  title: _vm.$t("modal.pix.delete-pix-key-modal.disclaimer"),
                },
              },
              [
                _c("template", { slot: "content" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("modal.pix.delete-pix-key-modal.paragraph-1")
                      ) +
                      " "
                  ),
                ]),
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "eu-display_flex eu-mt_5" },
              [
                _c("emerald-icon", { attrs: { icon: "check" } }),
                _c("p", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "modal.pix.delete-pix-key-modal.paragraph-2.half-1"
                        )
                      ) +
                      " "
                  ),
                  _c("strong", [_vm._v(_vm._s(_vm.accountName))]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "modal.pix.delete-pix-key-modal.paragraph-2.half-2"
                        )
                      ) +
                      " "
                  ),
                ]),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "input-container eu-display_flex eu-column" },
              [
                _c("passwordConfirmation", {
                  attrs: { value: _vm.pass, "data-testid": "input-pass" },
                  model: {
                    value: _vm.pass,
                    callback: function ($$v) {
                      _vm.pass = $$v
                    },
                    expression: "pass",
                  },
                }),
                _c(
                  "div",
                  {
                    staticClass:
                      "button-container eu-mt_3 eu-display_flex eu-justify_end",
                  },
                  [
                    _c("emd-button", {
                      attrs: {
                        "data-testid": "button-cancel",
                        type: "text",
                        disabled: _vm.isLoad,
                        text: _vm.$t("modal.pix.delete-pix-key-modal.button-1"),
                      },
                      on: { click: () => _vm.$emit("onCancel") },
                    }),
                    _c("emd-button", {
                      attrs: {
                        "data-testid": "button-delete-key",
                        color: "danger",
                        disabled: _vm.pass === "" || _vm.isLoad,
                        text: _vm.$t("modal.pix.delete-pix-key-modal.button-2"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onSubmit()
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }